<template>
  <div style="padding:1px;">
    <hd></hd>
    <el-row class="navBar">
      <el-col :span="24" class="nav">
        <el-col :xs="24" :sm="24" :md="2" :lg="2">
          <div class="title">
            您想问？
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6">
          <el-autocomplete
            style="width:100%"
            class="inline-input"
            :class="{mobileAuto:mobiletype}"
            v-model="keyword"
            :trigger-on-focus="false"
            prefix-icon="el-icon-search"
            :fetch-suggestions="querySearch"
            placeholder="请输入需要查询的问题"
            @select="handleSelect"
          ></el-autocomplete>
        </el-col>
      </el-col>
      
    </el-row>
    
    <div class="contioner">
      <el-row>
      <el-col :span="24" v-if="category">
        <div class="all"  >
          <div @click="select()">
            帮助中心
          </div>
          /
          <div @click="select(category)">
            {{category}}
          </div>
        </div>
        
      </el-col>
        <el-col :span="4" class="lg" v-if="!mobiletype">
          <div class="grid-content bg-purple lefttitle">
            <div class="">
              <ul>
                <li v-for="item in helpCategorys"  class="merchantcategory" @click="select(item)">
                  <span class="merchantCategoryDetails" :class="[item == category?'selected':'']">{{item}}</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="18" :md="18" :lg="18" >
          <div class="grid-content bg-purple-light">
            <div class="helpList">
              <ul class="">
                <li v-for="item in helpCategorys" v-if="!category">
                  <h3 class="cateforyTitle">{{item}}</h3>
                  <div v-for="(list,index) in helpList" v-if="item == list.category" class="subject subjectList" @click="subSelect(list)">
                    {{list.subject}}
                  </div>
                  <div class="subject more" style="text-decoration: underline !important;" @click="select(item)">更多</div>
                </li>
                <h2 class="cateforyTitle" v-if="category && !subject">{{category}}</h2>
                <div v-for="list in helpList" v-if="category && category == list.category && !subject"  class="subject" @click="subSelect(list)">
                    {{list.subject}}
                </div>
                <h2 class="cateforyTitle" v-if="subject">{{subject}}</h2>
                <div class="cotent" v-if="subject">
                  {{content}}
                </div>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')
export default {
    name: 'HelpCenter',
    components: {
      hd: hd,
      ft: ft,
      mobilefooter: mobilefooter,
      Loading: Loading,
    GlobalDialogs: GlobalDialogs
    },
    data() {
        return {
            screenWidth: document.body.clientWidth,
            mobiletype: false,
            category: '', //分类
            helpCategorys: '',
            helpList: '',
            subject: '',//标题
            content: '',//内容
            keyword: '',//搜索内容
        }
    },
    created() {
        if (document.body.clientWidth < 1024) {
          this.mobiletype = true
        }
        if(this.$route.query.category){
          this.category = '联系我们'
        }
        
        this.getInfo()
        this.getHelpCategory()
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()

      }
    },
    methods: {
        async getInfo() {
            let query = {
                category: this.category
            }
            let res = await api.getHelpList(this,query)
            this.helpList = res.body.result
        },
        async getHelpCategory () {
            let res = await api.getHelpCategory(this)
            this.helpCategorys = res.body.result
        },
        select (val) {
            console.log(val)
            this.$router.push('/HelpCenter')
            if(val) {
              this.category = val
              this.subject = ''
            }else{
              this.category = ''
              this.subject = ''
            }
            
            this.getInfo()
        },
        subSelect (list) {
          this.category = list.category
          this.subject = list.subject
          this.content = list.content
        },
        handleSelect (item) {
          this.category = item.category
          this.subject = item.value
          this.content = item.content
            this.getInfo()
        },
        async querySearch (queryString, cb) {
          let query = {
            keyword: queryString
          }
          let res = await api.searchHelpList(this,query)
          let list = []
          if(res.body.result) {
            _.each(res.body.result,item => {
              list.push({value: item.subject,category: item.category,content: item.content})
            })
          }
          console.log(list)
          cb(list);
        }
    },
    watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        },
        $route(to,from){
          if(to.query.category){
            this.category = '联系我们'
            this.getInfo()
          }
          if(to.query.category == ''){
            this.category = ''
            this.getInfo()
          }
        }
      }
}
</script>
<style scoped lang="scss">
.navBar {
    margin-top: 144px;
    .nav {
      overflow: hidden;
      border-bottom: 1px solid #d7d7d7;
      padding: 0 15%;
      height: 100px;
      line-height: 100px;
    }
    .title {
        color: #333333;
        vertical-align: middle;
        font-size: 20px;
        letter-spacing: 0.8px;
    }
    

}

.contioner {
    margin: 0 auto 60px;;
    padding-left: 15%;
    padding-right: 60px;
    padding-top: 78px;
    min-height: 400px;
    

    .all {
      color: #666;
      padding-left: 2%;
      cursor: pointer;
      position: relative;
      top: -62px;

      div {
        display: inline-block;
        font-size: 13px;
      }

      div:hover {
        text-decoration: underline !important;
      }
    }
     
    .merchantcategory {
        border: none !important;


        .merchantCategoryDetails {
            letter-spacing: 0.1px !important;
            white-space: nowrap !important;
            display: block !important;
            line-height: 24px !important;
            text-transform: capitalize !important;
            color: #666 !important;
            margin-bottom: 20px;
            cursor: pointer;
        }
        .merchantCategoryDetails:hover {
            text-decoration: underline !important;
        }
        .selected {
            color: #333;
            font-weight: bold;
            font-size: 15px;
        }
    }

    .helpList {

      h2 {
        height: 33px;
        line-height: 33px;
      }
      h3 {
        height: 33px;
        line-height: 33px;
      }

      li {
        float: left;
        width: 50%;
        margin-bottom: 64px;
        height: 227px;

        .subjectList:nth-child(n+5){
          display:none;
        }

        .more {
          display: none;
        }
        .more:nth-child(n+5){
          display: inline-block !important;
        }
      }

      .cateforyTitle {
        font-size: 22px;
        color: #333;
        margin-bottom: 22px;
      }

      .subject {
        cursor: pointer;
        height: 27px;
        line-height: 27px;
        font-size: 18px !important;
        color: #848484 !important;
        margin-bottom: 15px;
      }

      .subject:hover {
        text-decoration: underline !important;
      }

      .cotent {
        font-size: 15px !important;
        color: #848484 !important;
        line-height: 30px;
      }
    }
}
@media screen and (max-width:1024px){
  .navBar{
    margin-top: 50px;
    text-align: center;
    .nav {
      height: 148px;
      padding: 0 20px !important;
    }

    .title {
      margin-top: 20px;
      line-height: 30px;
    }
  }
  .contioner {
    padding: 68px 20px 0 20px;
    margin: 0 auto 0px;
    .all {
      top: -52px;
    }
    .helpList {
      li {
        width: 100%;
      }
    }
    .helpList {
      .cateforyTitle{
        height: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/HelpCenter/HelpCenter.vue